/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedSidebarFavorites_item = {
    readonly serviceId: string | null;
    readonly isAuctionEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"FavoritesItem_item">;
    readonly " $refType": "PdpSharedSidebarFavorites_item";
};
export type PdpSharedSidebarFavorites_item$data = PdpSharedSidebarFavorites_item;
export type PdpSharedSidebarFavorites_item$key = {
    readonly " $data"?: PdpSharedSidebarFavorites_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedSidebarFavorites_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSidebarFavorites_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesItem_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'd028dec9b94ea01b28dc132a5de82b9d';
export default node;
